import { useEffect, useRef, useState } from 'react';
import JsBarcode from 'jsbarcode';

const GenerateBarcode = ({ symbology, value, className = '' }) => {
  const canvasRef = useRef(null);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isInverted, setIsInverted] = useState(false);
  const [imageDataUrl, setImageDataUrl] = useState('');

  const getBarcodeFormat = () => {
    if (value && value.length > 13) {
      return 'CODE128';
    }
    return symbology || 'EAN13';
  };

  useEffect(() => {
    generateBarcodeImage();
  }, [symbology, value, isInverted]);

  const generateBarcodeImage = () => {
    if (!canvasRef.current) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const format = getBarcodeFormat();

    // Générer le barcode directement sur canvas
    JsBarcode(canvas, value, {
      format: format,
      displayValue: true,
      fontSize: 20,
      width: format === 'CODE128' ? 2 : 3,
      background: isInverted ? '#000000' : '#ffffff',
      lineColor: isInverted ? '#ffffff' : '#000000',
    });

    // Convertir en data URL pour l'affichage
    const dataUrl = canvas.toDataURL('image/png');
    setImageDataUrl(dataUrl);
  };

  const handleClick = () => {
    console.log('handleClick');
    if (!isAnimating) {
      setIsAnimating(true);
      setIsInverted(!isInverted);

      setTimeout(() => {
        setIsAnimating(false);
      }, 500);
    }
  };

  const containerStyle = {
    transition: 'transform 0.5s ease-in-out',
    transform: isAnimating ? 'scale(0.8)' : 'scale(1)',
  };

  return (
    <div className="space-y-4">
      {/* Affichage de l'image */}
      <div
        className="z-50 mb-2 cursor-pointer h-[142px] flex items-center justify-center"
        style={containerStyle}
      >
        {imageDataUrl && (
          <img
            src={imageDataUrl}
            alt="Barcode"
            onClick={handleClick}
            className={`max-h-full max-w-full object-contain ${className}`}
          />
        )}
      </div>

      {/* Canvas caché pour la génération */}
      <canvas
        ref={canvasRef}
        style={{ display: 'none' }}
      ></canvas>
    </div>
  );
};

export default GenerateBarcode;
